// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HLtYzhADsxKgj_qUCiWO {
  margin: 32px;
}

.I6noNFHr0DfX9kXs0_JJ {
  margin-top: 30px;
}

.HVsnOX4Dr9Uhel4ptjAI {
  height: 72px;
  gap: 10px;
  padding-bottom: 32px;
  font-family: var(--font-stack-full-medium);
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
}`, "",{"version":3,"sources":["webpack://./src/components/FilteredOverviewPage/FilteredOverviewPage.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,oBAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACF","sourcesContent":[".filters {\n  margin: 32px;\n}\n\n.scoreCards {\n  margin-top: 30px;\n}\n\n.tabTitle {\n  height: 72px;\n  gap: 10px;\n  padding-bottom: 32px;\n  font-family: var(--font-stack-full-medium);\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 32px;\n  letter-spacing: 0%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": `HLtYzhADsxKgj_qUCiWO`,
	"scoreCards": `I6noNFHr0DfX9kXs0_JJ`,
	"tabTitle": `HVsnOX4Dr9Uhel4ptjAI`
};
export default ___CSS_LOADER_EXPORT___;
